'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateCurrentCategory = updateCurrentCategory;
exports.updateShowSkeleton = updateShowSkeleton;
exports.updateScrollPosition = updateScrollPosition;
// Action Strings
var HOME_PAGE_UPDATE_CURRENT_CATEGORY = exports.HOME_PAGE_UPDATE_CURRENT_CATEGORY = 'HOME_PAGE_UPDATE_CURRENT_CATEGORY';
var HOME_PAGE_UPDATE_SHOW_SKELETON = exports.HOME_PAGE_UPDATE_SHOW_SKELETON = 'HOME_PAGE_UPDATE_SHOW_SKELETON';
var HOME_PAGE_UPDATE_SCROLL_POSITION = exports.HOME_PAGE_UPDATE_SCROLL_POSITION = 'HOME_PAGE_UPDATE_SCROLL_POSITION';

function updateCurrentCategory(currentCategory) {
    return function (dispatch) {
        return dispatch({
            type: HOME_PAGE_UPDATE_CURRENT_CATEGORY,
            currentCategory: currentCategory
        });
    };
}

function updateShowSkeleton(shouldShowSkeleton) {
    return function (dispatch) {
        return dispatch({
            type: HOME_PAGE_UPDATE_SHOW_SKELETON,
            shouldShowSkeleton: shouldShowSkeleton
        });
    };
}

function updateScrollPosition(scrollPositionY) {
    return function (dispatch) {
        return dispatch({
            type: HOME_PAGE_UPDATE_SCROLL_POSITION,
            scrollPositionY: scrollPositionY
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/actions/home-page.js
// module id = 782
// module chunks = 0